/* Not exported with the library. You'll want something similar to this for uniquely identifying external hosts in your App */
const AQMS = Symbol("AQMS2");
const IDADMIN = Symbol("IDADMIN");
const DOCGEN = Symbol("DOCGEN");

export const apiHosts = {
  AQMS,
  IDADMIN,
  DOCGEN,
};
